// import { Component, Input, Output, EventEmitter } from '@angular/core';
// import { ChatService } from '../chat.service';

// @Component({
//   selector: 'app-buyer-supplier-chat',
//   templateUrl: './buyer-supplier-chat.component.html',
//   styleUrls: ['./buyer-supplier-chat.component.css'],
// })
// export class BuyerSupplierChatComponent {
//   @Input() headerData: any; // data coming from rfq-details
//   messages: any[] = [];
//   @Input() isOpen: boolean = false;
//   @Input() showChatHistoryButton: boolean = true; // to control visibility of chat history button
//   @Input() rfqId: string = ''; // RFQ ID for the chat
//   @Input() userId: string = ''; // User ID of the current user
//   @Input() isSupplier: boolean = false;

//   @Output() close = new EventEmitter<void>();

//   newMessage: string = '';

//   constructor(private chatService: ChatService) {}
//   ngOnInit() {
//     // Connect WebSocket first
//     this.chatService.connect();
//     console.log('Header Data->', this.headerData);
//     console.log('RFQ ID->', this.rfqId);
//     console.log('User ID->', this.userId);
//     console.log('Is Supplier->', this.isSupplier);

//     // Example static messages (if you want to keep dummy data for testing)
//     // this.messages = [
//     //   { sender: 'You', message: 'Hello, how are you?', time: '08:00 PM' },
//     //   {
//     //     sender: 'Other',
//     //     message: 'I am good, thank you! How about you?',
//     //     time: '08:01 PM',
//     //   },
//     //   {
//     //     sender: 'You',
//     //     message: 'I’m doing well, thanks for asking.',
//     //     time: '08:02 PM',
//     //   },
//     //   {
//     //     sender: 'Other',
//     //     message: 'What about the delivery schedule?',
//     //     time: '08:05 PM',
//     //   },
//     //   {
//     //     sender: 'You',
//     //     message: 'The delivery will be in 5-7 business days.',
//     //     time: '08:06 PM',
//     //   },
//     //   { sender: 'Other', message: 'Great, thanks!', time: '08:07 PM' },
//     // ];

//     // Register logged-in user with socket (important for backend mapping)
//     // Step 2: Wait until connected before registering
//     this.chatService.onConnected().subscribe((isConnected) => {
//       if (isConnected) {
//         console.log('Registering user with ID:', this.userId);
//         this.chatService.registerUser(Number(this.userId));
//       }
//     });

//     // Subscribe to real-time incoming messages
//     this.chatService.getMessages().subscribe((messageData: any) => {
//       const incomingMessage = {
//         sender: messageData.senderId === Number(this.userId) ? 'You' : 'Other',
//         message: messageData.content, // backend sends { content: '...' }
//         time: new Date(messageData.createdAt || Date.now()).toLocaleTimeString(
//           [],
//           {
//             hour: '2-digit',
//             minute: '2-digit',
//           }
//         ),
//       };

//       this.messages.push(incomingMessage);
//       console.log('Updated messages list:', this.messages);
//     });

//     // Listen for typing notifications
//     this.chatService.getTypingNotification().subscribe((typingData: any) => {
//       console.log(
//         `${typingData.senderId} is typing in RFQ ${typingData.rfqId}`
//       );
//       // TODO: Show "User is typing..." indicator in the UI
//     });

//     console.log(
//       'In the buyer-supplier-chat component with message ->',
//       this.messages
//     );
//   }

//   closeChat() {
//     this.close.emit(); // notify parent to close
//   }

//   viewCommentHistory() {
//     // Replace with your actual logic
//     console.log('View Full Comment History clicked!');
//   }
//   isChatOpen = false;

//   // sendMessage() {
//   //   if (this.newMessage.trim()) {
//   //     // Create the message object to send
//   //     const messageData = {
//   //       content: this.newMessage, // Message typed by the sender
//   //       rfqId: Number(this.rfqId), // RFQ ID associated with the message
//   //       senderId: Number(this.userId), // User ID of the sender (either Buyer or Supplier)
//   //       receiverId: Number(this.headerData.buyerId), // User ID of the receiver (either Buyer or Supplier)
//   //     };
//   //     console.log('Message data to send:', messageData);

//   //     // Send the message to the backend via WebSocket
//   //     this.chatService.sendMessage(messageData);

//   //     // Add the message to the sender's chat UI immediately
//   //     const outgoingMessage = {
//   //       sender: 'You', // Sender is the current user (outgoing)
//   //       message: this.newMessage,
//   //       time: new Date().toLocaleTimeString(), // Show current time for simplicity
//   //     };

//   //     this.messages.push(outgoingMessage);
//   //     console.log('Sending message:', outgoingMessage);

//   //     // Clear the input field after sending the message
//   //     this.newMessage = '';
//   //   }
//   // }

//   sendMessage() {
//     if (this.newMessage.trim()) {
//       const messageData = {
//         content: this.newMessage,
//         rfqId: Number(this.rfqId),
//         senderId: Number(this.userId),
//         receiverId: this.isSupplier
//           ? Number(this.headerData.buyerId)
//           : Number(this.headerData.supplierId),
//         userId: Number(this.userId),
//       };

//       console.log('Message data to send:', messageData);

//       // ✅ Send the message via WebSocket
//       this.chatService.sendMessage(messageData);

//       // Optimistically add the message to UI
//       const outgoingMessage = {
//         sender: 'You',
//         message: this.newMessage,
//         time: new Date().toLocaleTimeString([], {
//           hour: '2-digit',
//           minute: '2-digit',
//         }),
//       };

//       this.messages.push(outgoingMessage);
//       console.log('Sending message:', outgoingMessage);

//       this.newMessage = '';
//     }
//   }

//   onFileSelected(event: Event) {
//     const file = (event.target as HTMLInputElement).files?.[0];
//     if (file) {
//       console.log('File selected:', file.name);
//       // Implement file upload logic here
//     }
//   }
//   formatDateToDDMMYYYY(dateString: string) {
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if day is less than 10
//     const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if month is less than 10
//     const year = date.getFullYear();

//     return `${day}/${month}/${year}`;
//   }
// }

// new code (Currently resolving the  issue)

import {
  Component,
  Input,
  Output,
  EventEmitter,
  type SimpleChanges,
} from '@angular/core';
import { ChatService } from '../chat.service';

@Component({
  selector: 'app-buyer-supplier-chat',
  templateUrl: './buyer-supplier-chat.component.html',
  styleUrls: ['./buyer-supplier-chat.component.css'],
})
export class BuyerSupplierChatComponent {
  @Input() headerData: any;
  @Input() isOpen: boolean = false;
  @Input() showChatHistoryButton: boolean = true;
  @Input() rfqId: string = '';
  @Input() userId: string = '';
  @Input() isSupplier: boolean = false;

  @Output() close = new EventEmitter<void>();

  //  Map to maintain messages for each chat (key = rfqId_senderId_receiverId)
  private messageMap: Map<string, any[]> = new Map();

  messages: any[] = [];
  newMessage: string = '';

  constructor(private chatService: ChatService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      // Chatbox is opened
      this.loadChatMessages();
    }
  }

  ngOnInit() {
    this.chatService.connect();
    console.log('Header Data->', this.headerData);
    console.log('RFQ ID->', this.rfqId);
    console.log('User ID->', this.userId);
    console.log('Is Supplier->', this.isSupplier);

    // Register current user when socket connects
    this.chatService.onConnected().subscribe((isConnected) => {
      if (isConnected) {
        console.log('Registering user with ID:', this.userId);
        this.chatService.registerUser(Number(this.userId));
      }
    });

    // Subscribe to incoming messages
    this.chatService.getMessages().subscribe((messageData: any) => {
      console.log('Received message data:', messageData);
      const chatKey = this.getChatKey(
        this.rfqId,
        messageData.senderId,
        messageData.receiverId
      );
      console.log('Chat Key for incoming message:', chatKey);

      const incomingMessage = {
        sender: messageData.senderId === Number(this.userId) ? 'You' : 'Other',
        message: messageData.content,
        time: new Date(messageData.createdAt || Date.now()).toLocaleTimeString(
          [],
          {
            hour: '2-digit',
            minute: '2-digit',
          }
        ),
      };

      if (!this.messageMap.has(chatKey)) {
        console.log(
          'Creating new message array for chat key while getting message:',
          chatKey
        );
        this.messageMap.set(chatKey, []);
      }

      this.messageMap.get(chatKey)!.push(incomingMessage);

      // If current active chat matches → update UI
      if (this.isCurrentChat(messageData)) {
        console.log('Message belongs to current chat, updating UI.');
        this.messages = [...this.messageMap.get(chatKey)!];
      }

      console.log('Updated messageMap:', this.messageMap);
    });

    // Typing notification
    this.chatService.getTypingNotification().subscribe((typingData: any) => {
      console.log(
        `${typingData.senderId} is typing in RFQ ${typingData.rfqId}`
      );
    });
  }

  private loadChatMessages(): void {
    if (!this.rfqId || !this.userId) return;

    const chatKey = this.getChatKey(
      this.rfqId,
      Number(this.userId),
      this.isSupplier
        ? Number(this.headerData.buyerId)
        : Number(this.headerData.supplierId)
    );

    if (this.messageMap.has(chatKey)) {
      // Already cached → populate from messageMap
      this.messages = [...this.messageMap.get(chatKey)!];
    }
    // else {
    //   // Not cached → fetch from backend
    //   this.chatService.getMessages(this.rfqId, this.userId, this.isSupplier).subscribe({
    //     next: (msgs) => {
    //       this.messages = msgs;

    //       // Store in map for reuse
    //       this.messageMap.set(chatKey, [...msgs]);
    //     },
    //     error: (err) => {
    //       console.error('Failed to load chat messages:', err);
    //     }
    //   });
    // }
    else {
      // Not cached → fetch from backend
      // this.chatService.getMessages(this.rfqId, this.userId, this.isSupplier).subscribe({
      //   next: (msgs) => {
      //     this.messages = msgs;

      //     // Store in map for reuse
      //     this.messageMap.set(chatKey, [...msgs]);
      //   },
      //   error: (err) => {
      //     console.error('Failed to load chat messages:', err);
      //   }
      // });

      console.log("headerData",this.headerData);
      const params = {
        rfqId: Number(this.rfqId),
        buyerId:Number(this.headerData.buyerId),
        supplierId: Number(this.headerData.supplierId),
      };

      this.chatService.getChatHistory(params).subscribe((history: any[]) => {
        const formatted = history.map((msg) => ({
          sender: msg.senderId === Number(this.userId) ? 'You' : 'Other',
          message: msg.message,   
          // time: new Date(msg.createdAt).toLocaleTimeString(),
          time: msg.time,
        }));

        this.messageMap.set(chatKey, formatted);
        this.messages = [...formatted];

        console.log('Fetched chat history:', this.messages);
      });

    }
  }

  //  Build unique key per chat
  private getChatKey(
    rfqId: string,
    senderId: number,
    receiverId: number
  ): string {
    const sorted = [senderId, receiverId].sort((a, b) => a - b);
    return `${rfqId}_${sorted[0]}_${sorted[1]}`;
  }

  // ✅ Check if the incoming message belongs to the active chat
  private isCurrentChat(messageData: any): boolean {
    const currentKey = this.getChatKey(
      this.rfqId,
      Number(this.userId),
      this.isSupplier
        ? Number(this.headerData.buyerId)
        : Number(this.headerData.supplierId)
    );

    const incomingKey = this.getChatKey(
      messageData.rfqId,
      messageData.senderId,
      messageData.receiverId
    );
    console.log('Current Chat Key:', currentKey);
    console.log('Incoming Message Key:', incomingKey);

    return currentKey === incomingKey;
  }

  //  When opening a chat → load from map or fetch first time
  loadChat() {
    const otherId = this.isSupplier
      ? Number(this.headerData.buyerId)
      : Number(this.headerData.supplierId);

    const chatKey = this.getChatKey(this.rfqId, Number(this.userId), otherId);

    if (this.messageMap.has(chatKey)) {
      this.messages = [...this.messageMap.get(chatKey)!];
      console.log('Loaded messages from cache:', this.messages);
    }
    // } else {
    //   // First-time load → fetch from backend (e.g., last 20 messages)
    //   this.chatService.getChatHistory(this.rfqId, Number(this.userId), otherId).subscribe((history: any[]) => {
    //     const formatted = history.map((msg) => ({
    //       sender: msg.senderId === Number(this.userId) ? 'You' : 'Other',
    //       message: msg.content,
    //       time: new Date(msg.createdAt).toLocaleTimeString(),
    //     }));

    //     this.messageMap.set(chatKey, formatted);
    //     this.messages = [...formatted];

    //     console.log('Fetched chat history:', this.messages);
    //   });
    // }

     else {
      const messageData = {
        rfqId: Number(this.rfqId),
        buyerId:Number(this.headerData.buyerId),
        supplierId: Number(this.headerData.supplierId),
      };

      // this.chatService.getMessagesHistory(messageData).subscribe((history: any[]) => {
      //   const formatted = history.map((msg) => ({
      //     sender: msg.senderId === Number(this.userId) ? 'You' : 'Other',
      //     message: msg.content,
      //     time: new Date(msg.createdAt).toLocaleTimeString(),
      //   }));

      //   this.messageMap.set(chatKey, formatted);
      //   this.messages = [...formatted];

      //   console.log('Fetched chat history:', this.messages);
      // });

      // this.chatService.getChatHistory(messageData).subscribe({
      //   next: (history: any[]) => {
      //     this.messages = history.map((msg) => ({
      //       sender: msg.senderId === Number(this.userId) ? 'You' : 'Other',
      //       message: msg.message,             
      //       // senderId: msg.senderId,
      //       // receiverId: msg.receiverId,
      //       // isSupplier: msg.isSupplier,
      //       time: msg.time,            
      //     }));
      //     console.log("Loaded chat history:", this.messages);
      //   },
      //   error: (err:any) => {
      //     console.error("Failed to load chat history:", err);
      //   }
      // });

      this.chatService.getChatHistory(messageData).subscribe((history: any[]) => {
        const formatted = history.map((msg) => ({
          sender: msg.senderId === Number(this.userId) ? 'You' : 'Other',
          message: msg.message,   
          time: new Date(msg.createdAt).toLocaleTimeString(),
        }));

        this.messageMap.set(chatKey, formatted);
        this.messages = [...formatted];

        console.log('Fetched chat history:', this.messages);
      });

    }
  }

  sendMessage() {
    if (this.newMessage.trim()) {
      const receiverId = this.isSupplier
        ? Number(this.headerData.buyerId)
        : Number(this.headerData.supplierId);
      console.log('Receiver ID:', receiverId);
      console.log('Receiver is supplier:', this.isSupplier);

      // const messageData = {
      //   content: this.newMessage,
      //   rfqId: Number(this.rfqId),
      //   senderId: Number(this.userId),
      //   receiverId: receiverId,
      //   userId: Number(this.userId),
      // };
       const messageData = {
        content: this.newMessage,
        rfqId: Number(this.rfqId),
        senderId: Number(this.userId),
        receiverId: receiverId,
        userId: Number(this.userId),
        isSupplier: this.isSupplier,
      };

      console.log('Message data to send:', messageData);

      // Send via WebSocket
      // this.chatService.sendMessage(messageData,this.isSupplier);
      this.chatService.sendMessage(messageData);

      // Optimistic UI update
      const outgoingMessage = {
        sender: 'You',
        message: this.newMessage,
        time: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        }),
      };

      const chatKey = this.getChatKey(
        this.rfqId,
        Number(this.userId),
        receiverId
      );
      console.log('Chat Key for sending message:', chatKey);

      if (!this.messageMap.has(chatKey)) {
        console.log('Creating new message array for chat key:', chatKey);
        this.messageMap.set(chatKey, []);
      }

      this.messageMap.get(chatKey)!.push(outgoingMessage);

      this.messages = [...this.messageMap.get(chatKey)!];

      this.newMessage = '';
    }
  }

  // Programmatic send without relying on current header inputs or opening UI
  // Used by parent components to fire reminder messages silently
  sendProgrammaticMessage(rfqId: number, receiverId: number, content: string) {
    if (!content || !String(content).trim()) return;

    const messageData = {
      content: content,
      rfqId: Number(rfqId),
      senderId: Number(this.userId),
      receiverId: Number(receiverId),
      userId: Number(this.userId),
      isSupplier: this.isSupplier
    };

    this.chatService.sendMessage(messageData);

    const outgoingMessage = {
      sender: 'You',
      message: content,
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      }),
    };

    const chatKey = this.getChatKey(
      String(rfqId),
      Number(this.userId),
      Number(receiverId)
    );

    if (!this.messageMap.has(chatKey)) {
      this.messageMap.set(chatKey, []);
    }
    this.messageMap.get(chatKey)!.push(outgoingMessage);

    // Do not overwrite messages UI if a different chat is currently shown
    if (this.isCurrentChat({ rfqId, senderId: Number(this.userId), receiverId })) {
      this.messages = [...this.messageMap.get(chatKey)!];
    }
  }

  closeChat() {
    this.messages = []; // Clear messages on close
    this.close.emit();
  }

  viewCommentHistory() {
    console.log('View Full Comment History clicked!');
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      console.log('File selected:', file.name);
      // TODO: File upload logic
    }
  }

  formatDateToDDMMYYYY(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
